<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="3xl" [customTitle]="(id ? 'Editar' : 'Nuevo') + ' tipo de producto'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">
        <div class="grid grid-cols-1 gap-4">

            <custom-input [autofocus]="true" label="Nombre" type="text" [formControlItem]="saveForm.get('name')">
            </custom-input>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="has_allergens"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2 transition-all duration-200">
                <div class="flex items-center gap-2">
                    <span class="text-sm relative z-10 font-medium text-neutral-700">Admite alérgenos</span>
                    <span class="text-xs text-neutral-500">
                        Los productos de este tipo podrán marcar qué alérgenos contienen
                    </span>
                </div>
            </label>

            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="stock_control"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2 transition-all duration-200">
                <div class="flex items-center gap-2">
                    <span class="text-sm relative z-10 font-medium text-neutral-700">Controlar stock</span>
                    <span class="text-xs text-neutral-500">
                        No se podrá vender un producto de este tipo si no hay stock suficiente
                    </span>
                </div>
            </label>

        </div>
    </form>

    <div class="mt-6 pt-4 border-t border-neutral-200">
        @if(id){
        <app-product-type-attributes [productTypeId]="id"></app-product-type-attributes>
        } @else {
        <p class="text-xs text-neutral-500">
            Guarda el tipo de producto para poder añadirle atributos de variación (talla, color...).
        </p>
        }
    </div>
</app-custom-modal>
}
